import { AccountContext } from '@views/contexts'
import { useContext } from 'react'

export const useAccount = () => useContext(AccountContext)
